import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld.vue'
import AllImgFile from '@/components/AllImgFile.vue'



Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'HelloWorld',
			component: HelloWorld
		},
		{
			path: '/all-img',
			name: 'AllImgFile',
			component: AllImgFile
		}
	]
})